import React, { PureComponent } from 'react';
import { Input } from 'antd';
import get from 'lodash/get';

import LinkTypeEnum from 'redpoints-model-js/enumeration/LinkTypeEnum';

import { Field, Form, Spin } from 'redpoints-front-components';

import LinksManagementViewerLinkListCounter from './LinksManagementViewerLinkListCounter';
import { translate } from '../../../helpers/languageHelper';
import { isUrlsLimitValid } from './linksManagementHelpers';

const getLabel = linkType => {
  if (linkType.name === LinkTypeEnum.DETECTION.name) {
    return translate('tasks.links_management.lists.labels.detection');
  } else if (linkType.name === LinkTypeEnum.CONTENT.name) {
    return translate('tasks.links_management.lists.labels.content');
  }
};

class LinksManagementViewerLinkList extends PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.handleChange(get(event, 'target.value', ''));
  }

  render() {
    const { Item } = Form;
    const { isLoading, linkType, linkUrls } = this.props;

    return (
      <>
        <LinksManagementViewerLinkListCounter linkType={linkType} />
        <Spin spinning={isLoading}>
          <Field label={getLabel(linkType)} rpElement="TextArea">
            <Item
              className="links-management-form-item"
              initialValue={linkUrls}
              name={linkType.name}
              onChange={this.handleChange}
              rules={[
                {
                  validator: async (_, value) => {
                    if (isUrlsLimitValid(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(translate('form.error_text_lines_limit'))
                    );
                  },
                },
              ]}
            >
              <Input.TextArea aria-label="linkUrlsTextArea" rows={8} />
            </Item>
          </Field>
        </Spin>
      </>
    );
  }
}

export default LinksManagementViewerLinkList;
